import {
  Container,
  StyledMarker,
  StyledTitle,
} from './AddonCardTitle.styles';

const AddonCardTitle = ({text, isRecommended}) => {
  return (
    <Container>
      <StyledMarker />
      <StyledTitle
        recommended={isRecommended ? 'true' : undefined}
      >
        {text}
      </StyledTitle>
    </Container>
  );
};

export default AddonCardTitle;
